/* eslint-disable  jsx-a11y/label-has-associated-control */ 

import React, { useEffect, useMemo, useState } from 'react';
// import debounce from 'debounce';
// import { makeStyles } from '@material-ui/core/styles';
// import { TextField, CircularProgress, InputAdornment } from '@material-ui/core';
import Select from 'react-select';

const UserSearchCommunity = (props) => {
    const {inputLabel , classes, onCommunityValueChange,suggestionsListByCommunity=[],getSuggestionsCommunityAPI,isLoading,listCommunitesChallenge:listCommunites} = props || {}
    const [optionList, setOptionList] = React.useState([]);
    const [selected, setSelected] = useState([]);
    const [searchText, setSearchText] = useState('');

    useEffect(()=>{
      const challengeOwnerOption = listCommunites.map(group =>  ({value: group.id, label: group.name}));
      setOptionList(challengeOwnerOption)
  },[])

  // console.log("selected==> search community", selected)

  return(
        <fieldset className='fieldsetBox'>
            {/* <label htmlFor='communities'  > Search Communities </label> */}
            
                    <Select
                    options={optionList}

                    value={selected} // controlled
                    placeholder="Search..."
                    isSearchable
                    isClearable
                    onChange={(option) => {
                      // option is { value, label } | null
                      setSelected(option);
                      if (onCommunityValueChange) {
                        onCommunityValueChange(option); // pass raw value + whole option object
                      }
                    }}
                    onInputChange={(input, { action }) => {
                      // capture user typing in the search box
                      if (action === 'input-change') {
                        setSearchText(input);
                      }
                    }}

                    // isSearchable={isSearchable}
                    // isMulti
                    // placeholder="Search..."
                    // id="communities"
                    // styles={{
                    //     control: (baseStyles, state) => ({
                    //       ...baseStyles,
                    //       borderColor: '#333',
                    //     }),
                    //   }}
                  />
                    
                
            
            
        </fieldset>
  )

}

export default UserSearchCommunity